function checkout__initAddressAdd(formId, userId, formSelectShippingAddressId, formSelectShippingAddressProvinceId) {
    log('checkout__initAddressAdd');

    $(document).on('click', '.js-shipping-addNewAddress', function () {
        $('[data-js="modal-shipping-address-add"]').modal('show');
    });

    $(document).on('submit', '#'+formId, function (e) {
        e.preventDefault();
        var form = $(this);
        $.post('/api/address/save?user='+userId, form.serializeArray(), function (data) {
            // log(data.html);
            $('#shipping-form-wrapper').html(data.html);

            if (data.result) {
                $('[data-js="modal-shipping-address-add"]').modal('hide');
                // update address-mixed
                // var newAddress = $('<option value="'+data.address.id+'" data-type="">'+data.address.label+'</option>');
                // $("#"+formSelectShippingAddressId+"-mixed").append(newAddress);
                // setTimeout(function () {
                //     $("#"+formSelectShippingAddressId+"-mixed").val(data.address.id);
                // }, 500);
                // update address
                var newAddress = $('<option value="'+data.address.id+'" data-locale="'+data.address.locale+'">'+data.address.label+'</option>');
                $("#"+formSelectShippingAddressId).append(newAddress);
                // $("select").selectric({maxHeight: 200});
                setTimeout(function () {
                    $("#"+formSelectShippingAddressId).val(data.address.id);
                    // $("#"+formSelectShippingAddressId).selectric({maxHeight: 200});
                    shippingMethodChange();
                }, 500);
            } else {
                // $("select").selectric({maxHeight: 200});
                if (logged) {
                    shippingAddressCountryChange();
                } else {
                    anon_shippingAddressCountryChange();
                }
            }
        });
    });
}

function reservedArea__initAddressAdd(formId, userId) {
    log('reservedArea__initAddressAdd');

    $(document).on('click', '.js-shipping-addNewAddress', function () {
        $('input').val('');
        // $('#ecommerce_shipping_address_address_province').val('').selectric('refresh');

        shippingAddressCountryChange();

        $('[data-js="modal-shipping-address-add"]').modal('show');

    });

    $(document).on('submit', '#'+formId, function (e) {
        e.preventDefault();
        var form = $(this);
        $.post('/api/address/save?user='+userId+'&type=reservedArea', form.serializeArray(), function (data) {
            // log(data.html);
            $('#shipping-form-wrapper').html(data.html);

            if (data.result) {
                $('[data-js="modal-shipping-address-add"]').modal('hide');

                if(data.replace > 0) {
                    $('.addressBox[data-address-id="'+data.replace+'"]').replaceWith(data.address.reservedAreaBox);
                }
                else {
                    $('#addressesContainer').append(data.address.reservedAreaBox);
                }
            }

            // $("select").selectric({maxHeight: 200});
        });
    });
}

function initAddressEdit(addressID) {
    log('initAddressEdit');

    $('#ecommerce_shipping_address_existent_address').val(addressID);
    var box = $('.addressBox[data-address-id="'+addressID+'"]');

    var provinceVal;
    $('#ecommerce_shipping_address_address_province option').each(function () {
        if($(this).text().includes(box.attr('data-address-province'))) {
            provinceVal = $(this).val();
        }
    });

    $('input[name="ecommerce_shipping_address[address_firstName]"]').val(box.attr('data-address-name'));
    $('input[name="ecommerce_shipping_address[address_lastName]"]').val(box.attr('data-address-lastName'));
    $('input[name="ecommerce_shipping_address[address_address]"]').val(box.attr('data-address-address'));
    $('input[name="ecommerce_shipping_address[address_cap]"]').val(box.attr('data-address-cap'));
    $('input[name="ecommerce_shipping_address[address_city]"]').val(box.attr('data-address-city'));
    $('#ecommerce_shipping_address_address_province').val(provinceVal)
        // .selectric('refresh')
    ;
    $('#ecommerce_shipping_address_address_country').val(box.attr('data-address-country'))
        // .selectric('refresh')
    ;
    $('input[name="ecommerce_shipping_address[address_phoneNumber]"]').val(box.attr('data-address-phoneNumber'));

    shippingAddressCountryChange();

    $('[data-js="modal-shipping-address-add"]').modal('show');
}

function deleteAddress(addressID) {
    $.post('/api/address/delete?addressID='+addressID, null, function (data) {
        if (data.result) {
            $('.addressBox[data-address-id="'+addressID+'"]').remove();
        }
    });
}

function useBillingAddress(e) {
    log('useBillingAddress');

    if(e.checked) {
        // $('input[name^="ecommerce_shipping_address"]').attr('disabled', 'disabled');

        $('input[name="ecommerce_shipping_address[address_firstName]"]').val($('input[name="ecommerce_order[billingName]"]').val());
        $('input[name="ecommerce_shipping_address[address_lastName]"]').val($('input[name="ecommerce_order[billingLastName]"]').val());
        $('input[name="ecommerce_shipping_address[address_address]"]').val($('input[name="ecommerce_order[billingAddress]"]').val());
        $('input[name="ecommerce_shipping_address[address_cap]"]').val($('input[name="ecommerce_order[billingCap]"]').val());
        $('input[name="ecommerce_shipping_address[address_city]"]').val($('input[name="ecommerce_order[billingCity]"]').val());
        $('#ecommerce_shipping_address_address_province').val($('#ecommerce_order_billingProvince').val())
            // .selectric('refresh')
        ;
        $('#ecommerce_shipping_address_address_country').val($('#ecommerce_order_billingCountry').val())
            // .selectric('refresh')
        ;
        $('input[name="ecommerce_shipping_address[address_phoneNumber]"]').val($('input[name="ecommerce_order[billingPhone]"]').val());

        shippingAddressCountryChange();
    }
    else {
        $('input[name^="ecommerce_shipping_address"]').removeAttr('disabled');
    }
}

function anon_useBillingAddress(e) {
    log('anon_useBillingAddress');

    if(e.checked) {
        // $('input[name^="ecommerce_order"]').attr('disabled', 'disabled');

        $('input[name="ecommerce_order[address_firstName]"]').val($('input[name="ecommerce_order[billingName]"]').val());
        $('input[name="ecommerce_order[address_lastName]"]').val($('input[name="ecommerce_order[billingLastName]"]').val());
        $('input[name="ecommerce_order[address_address]"]').val($('input[name="ecommerce_order[billingAddress]"]').val());
        $('input[name="ecommerce_order[address_cap]"]').val($('input[name="ecommerce_order[billingCap]"]').val());
        $('input[name="ecommerce_order[address_city]"]').val($('input[name="ecommerce_order[billingCity]"]').val());
        $('#ecommerce_order_address_province').val($('#ecommerce_order_billingProvince').val())
        // .selectric('refresh')
        ;
        $('#ecommerce_order_address_country').val($('#ecommerce_order_billingCountry').val())
        // .selectric('refresh')
        ;
        $('input[name="ecommerce_order[address_phoneNumber]"]').val($('input[name="ecommerce_order[billingPhone]"]').val());

        anon_shippingAddressCountryChange();
    }
    else {
        $('input[name^="ecommerce_order"]').removeAttr('disabled');
    }
}
$('#sentence_for_abroad').html($('#ecommerce_order_billingCountry').find(":selected").data('example'));
function addressCountryChange() {
    log('addressCountryChange');

    if (!$('#ecommerce_order_billingCountry').val()) {
        $('.hide-billingCountryEmpty').hide();
    } else {
        $('.hide-billingCountryEmpty').show();
    }
 
    if($('#ecommerce_order_billingCountry').val() == italy_id) {
        $('.hide-billingCountryNotIt').show();
        $('#sentence_for_abroad').html($('#ecommerce_order_billingCountry').find(":selected").data('example'));
        // $('.hide-billingCountryNotIt-changeW').addClass('col-sm-3');
        // $('#sentence_for_abroad').addClass('D(n)');
    } else {
        $('.hide-billingCountryNotIt').hide();
        // $('.hide-billingCountryNotIt-changeW').removeClass('col-sm-3');
        $('#sentence_for_abroad').html($('#ecommerce_order_billingCountry').find(":selected").data('example'));
        // [RIMUOVERE]
        // $('#sentence_for_abroad').removeClass('D(n)');
    }
}

function shippingAddressCountryChange() {
    log('shippingAddressCountryChange');

    if (!$('#ecommerce_shipping_address_address_country').val()) {
        $('.hide-shippingCountryEmpty').hide();
    } else {
        $('.hide-shippingCountryEmpty').show();
    }

    if($('#ecommerce_shipping_address_address_country').val() == italy_id) {
        $('.hide-shippingCountryNotIt').removeClass('D(n)');
        // $('.hide-shippingCountryNotIt-changeW').addClass('col-sm-2').removeClass('col-sm-4');
    }
    else {
        $('.hide-shippingCountryNotIt').addClass('D(n)');
        // $('.hide-shippingCountryNotIt-changeW').addClass('col-sm-4').removeClass('col-sm-2');
    }

    if (typeof _callback_shippingAddressCountryChange == 'function') {
        _callback_shippingAddressCountryChange();
    }
}

function anon_shippingAddressCountryChange() {
    log('anon_shippingAddressCountryChange');

    if (!$('#ecommerce_order_address_country').val()) {
        $('.hide-shippingCountryEmpty').hide();
    } else {
        $('.hide-shippingCountryEmpty').show();
    }

    if($('#ecommerce_order_address_country').val() == italy_id) {
        $('.hide-shippingCountryNotIt').removeClass('D(n)');
        // $('.hide-shippingCountryNotIt-changeW').addClass('col-sm-2').removeClass('col-sm-4');
    }
    else {
        $('.hide-shippingCountryNotIt').addClass('D(n)');
        // $('.hide-shippingCountryNotIt-changeW').addClass('col-sm-4').removeClass('col-sm-2');
    }

    if (typeof _callback_shippingAddressCountryChange == 'function') {
        _callback_shippingAddressCountryChange();
    }
}

function shippingMethodChange() {
    // var address_locale = $('#ecommerce_order_shippingAddress').find(':selected').attr('data-locale');

    // if(address_locale == default_locale || address_locale === undefined) {
    //     $('input[name="ecommerce_order[shippingMethod]"]').each(function () {
    //         var new_label = $(this).attr('data-description');
    //         $(this).next().html(new_label);
    //     });
    // }
    // else {
    //     $('input[name="ecommerce_order[shippingMethod]"]').each(function () {
    //         var new_label = $(this).attr('data-description-foreign');
    //         $(this).next().html(new_label);
    //     });
    // }

    if (typeof _callback_shippingMethodChange == 'function') {
        _callback_shippingMethodChange();
    }
}